"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REHYDRATE_COMPLETE = void 0;
var REHYDRATE_COMPLETE;
(function (REHYDRATE_COMPLETE) {
    REHYDRATE_COMPLETE["ACTION"] = "REHYDRATE_COMPLETE_ACTION";
})(REHYDRATE_COMPLETE = exports.REHYDRATE_COMPLETE || (exports.REHYDRATE_COMPLETE = {}));
//# sourceMappingURL=rehydrateComplete.js.map